import {Injectable} from '@angular/core';
import {CardApi} from '../../api/card/card.api.class';
import {Observable} from 'rxjs';
import CallbackRequestCard from 'src/app/interfaces/card/requests/CallbackRequestCard';
import { BinLookupRequest } from 'src/app/interfaces/card/requests/bin-lookup-request';

@Injectable({
  providedIn: 'root'
})
export class CardService {

  constructor(private cardApi: CardApi) { }

  public initiateTransaction(type, body, sessionToken): Observable<object> {
    return this.cardApi.initiateTransaction(type, body, sessionToken);
  }
  public initiateGooglePayTransaction(body, sessionToken): Observable<object> {
    return this.cardApi.initiateGooglePayTransaction(body, sessionToken);
  }
  public initiateApplePayTransaction(body, sessionToken): Observable<object> {
    return this.cardApi.initiateApplePayTransaction(body, sessionToken);
  }

  public initiateInstalment(type, body, sessionToken): Observable<object> {
    return this.cardApi.initiateInstalmentTransaction(type, body, sessionToken);
  }

  public authoriseTransaction(sessionToken): Observable<object> {
    return this.cardApi.authoriseTransaction(sessionToken);
  }

  public callback(body: CallbackRequestCard): Observable<object> {
    return this.cardApi.callback(body);
  }

  public deleteCard(cardToken: string, sessionToken: string): Observable<any> {
    return this.cardApi.deleteCard(cardToken, sessionToken);
  }

  public verifyCard(body, sessionToken): Observable<object> {
    return this.cardApi.verifyCard(body, sessionToken);
  }

  public binLookup(request: BinLookupRequest) {
    return this.cardApi.binLookup(request);
  }

}
